import { InjectionToken } from '@angular/core';
export const ADDITIONAL_AUTOCOMPLETER_QUERY_PARAMS = new InjectionToken('autocompleter additional query params');
